// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/alert/style/index.less
// module id = 1053
// module chunks = 1